<template lang="pug">
.d-flex.custom-border.rounded-lg.px-2.py-3
  .flex-grow-1.mt-1
    template(v-for="(filter, idx) in allFilters")
      filter-birthday.mr-2(v-if="filter.id === 'birthday'" :filter.sync="filter.filter" check-initial-value :key="`${filter.id}-${idx}`")
      filter-age.mr-2(v-if="filter.id === 'dob__year'" :filter.sync="filter.filter" check-initial-value :key="`${filter.id}-${idx}`")
      filter-gender.mr-2(v-if="filter.id === 'gender'" :filter.sync="filter.filter" check-initial-value :key="`${filter.id}-${idx}`")
      filter-nationality.mr-2(v-if="filter.id === 'nationality'" :filter.sync="filter.filter" check-initial-value :key="`${filter.id}-${idx}`")
      filter-race.mr-2(v-if="filter.id === 'race'" :filter.sync="filter.filter" check-initial-value :key="`${filter.id}-${idx}`")
      filter-religion.mr-2(v-if="filter.id === 'religion'" :filter.sync="filter.filter" check-initial-value :key="`${filter.id}-${idx}`")
      filter-total-visit.mr-2(v-if="filter.id === 'total_visit'" :filter.sync="filter.filter" check-initial-value :key="`${filter.id}-${idx}`")
      filter-medications.mr-2(v-if="filter.id === 'medication'" :filter.sync="filter.filter" check-initial-value :key="`${filter.id}-${idx}`")
      filter-services.mr-2(v-if="filter.id === 'service'" :filter.sync="filter.filter" check-initial-value :key="`${filter.id}-${idx}`")
      filter-date.mr-2(v-if="filter.id === 'last_purchase'" :filter.sync="filter.filter" check-initial-value title="Last purchase" param="last_purchase" :key="`${filter.id}-${idx}`")
      filter-postcode.mr-2(v-if="filter.id === 'postcodes'" :filter.sync="filter.filter" check-initial-value :key="`${filter.id}-${idx}`")
      filter-date.mr-2(v-if="filter.id === 'purchase_date'" :filter.sync="filter.filter" check-initial-value title="Purchase date" param="purchase_date" :key="`${filter.id}-${idx}`")
      filter-lifetime-value.mr-2(v-if="filter.id === 'lifetime_value'" :filter.sync="filter.filter" check-initial-value :key="`${filter.id}-${idx}`")
      filter-date.mr-2(v-if="filter.id === 'joined_date'" :filter.sync="filter.filter" check-initial-value title="Membership joined date" param="joined_date" :key="`${filter.id}-${idx}`")
      filter-rating.mr-2(v-if="filter.id === 'google_review_star'" :filter.sync="filter.filter" check-initial-value title="Google reviews" :options="['4','5']" param="google_review_star" :key="`${filter.id}-${idx}`")
      filter-request-status.mr-2(v-if="filter.id === 'review_invite_status'" :filter.sync="filter.filter" check-initial-value :key="`${filter.id}-${idx}`")
      filter-rating.mr-2(v-if="filter.id === 'review_star'" :filter.sync="filter.filter" check-initial-value title="Feedback rating" :options="['1','2','3']" param="review_star" :key="`${filter.id}-${idx}`")
    add-filter-dropdown.mr-2(@added="addFilter($event)")
    v-tooltip(top color="black" content-class="black tooltip-top-arrow")
      template(#activator="{ on, attrs }")
        v-icon.mr-2(color="neutral500" size="20" v-bind="attrs" v-on="on" style="margin-top: 2px;") mdi-information-outline
      div.py-1(style="max-width: 320px;")
        div.text-xs.font-semibold Dynamic segment
        div.text-xs Set a segmentation rule for your customer division. Changes on the customer status will be automatically updated.
    span.text-sm.font-medium.clickable.ma-3(v-if="allFilters.length" @click="clearAllFilter" style="white-space: nowrap;") Clear all
  div(style="white-space: nowrap;")
    y-button.mr-2(:label="$t('cancel')" underline color="neutral700" size="sm" button-class="px-0" @click="closeEdit")
    y-button(label="Save" text-color="neutral100" color="neutral700" size="sm" dark :loading="isLoading" @click="saveData")
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import AddFilterDropdown from '@/components/clinic/patient/filters/AddFilterDropdown.vue'
import FilterBirthday from '@/components/module/filter/FilterBirthday.vue'
import FilterDate from '@/components/module/filter/FilterDate.vue'
import FilterAge from '@/components/module/filter/FilterAge.vue'
import FilterGender from '@/components/clinic/patient/filters/FilterGender.vue'
import FilterNationality from '@/components/clinic/patient/filters/FilterNationality.vue'
import FilterRace from '@/components/clinic/patient/filters/FilterRace.vue'
import FilterReligion from '@/components/clinic/patient/filters/FilterReligion.vue'
import FilterLifetimeValue from '@/components/clinic/patient/filters/FilterLifetimeValue.vue'
import FilterTotalVisit from '@/components/clinic/patient/filters/FilterTotalVisit.vue'
import FilterMedications from '@/components/clinic/patient/filters/FilterMedications.vue'
import FilterServices from '@/components/clinic/patient/filters/FilterServices.vue'
import FilterPostcode from '@/components/clinic/patient/filters/FilterPostcode.vue'
import FilterRating from '@/components/clinic/patient/filters/FilterRating.vue'
import FilterRequestStatus from '@/components/clinic/patient/filters/FilterRequestStatus.vue'

export default {
  components: {
    AddFilterDropdown, FilterBirthday, FilterDate, FilterAge, FilterGender, FilterNationality, FilterRace, FilterReligion,
    FilterLifetimeValue, FilterTotalVisit, FilterMedications, FilterServices, FilterPostcode, FilterRating, FilterRequestStatus
  },
  props: ['segment'],
  data: () => ({
    isLoading: false,
    allParams: null,
    allFilters: [],
    key: 0,
    nameFilter: {},
    idFilter: {},
    phoneFilter: {},
    emailFilter: {},
    ageFilter: {},
    genderFilter: {},
    nationalityFilter: {},
    raceFilter: {},
    religionFilter: {},
    lifetimeValueFilter: {},
    totalVisitFilter: {},
    medicationFilter: {},
  }),
  computed: {
    ...mapGetters({ company: 'getCompany' }),
  },
  mounted () {
    this.setData()
  },
  methods: {
    ...mapActions(['showMessage']),
    setData () {
      if (this.segment.extra_data.filters && this.segment.extra_data.filters.length) {
        this.allFilters = JSON.parse(JSON.stringify(this.segment.extra_data.filters))
      }
      if (this.segment.filter_params) {
        this.allParams = this.segment.filter_params
      }
    },
    addFilter (item) {
      this.allFilters.push(item)
    },
    clearAllFilter () {
      this.allFilters = []
    },
    saveData () {
      this.isLoading = true
      let obj = {}
      this.allFilters = this.allFilters.filter(f => f.filter.key)
      this.allFilters.forEach(filter => {
        if (['last_purchase','purchase_date','joined_date','dob__year','total_visit','lifetime_value'].includes(filter.id)) {
          if (filter.filter.key === 'between') {
            filter.filter.value.forEach(o => { obj[o.key] = o.value })
          } else {
            obj[filter.filter.key] = filter.filter.value
          }
        }
        if (['gender','nationality','race','religion','medication','service','postcodes','google_review_star','review_invite_status','review_star'].includes(filter.id)) {
          obj[filter.filter.key] = filter.filter.value
        }
        if (filter.id === 'birthday') {
          if (['birthday_between','dob_month_between'].includes(filter.filter.key)) {
            filter.filter.value.forEach(o => { obj[o.key] = o.value })
          } else {
            obj[filter.filter.value.key] = filter.filter.value.value
          }
        }
      })
      let params = this.convertObjectToURLParams(obj)
      let data = {
        filter_params: params,
        extra_data: { filters: this.allFilters }
      }
      this.$axios.patch(`/connect/${this.company.slug}/groups/${this.segment.id}`, data)
        .then(resp => {
          this.$emit('update:segment', resp.data)
          this.$emit('updated')
        })
        .catch(err => {
          let message = this.$t('error_message.unable_to_complete_request')
          if (err.response.data) {
            if (err.response.data.detail) {
              message = err.response.data.detail
            } else {
              let data = JSON.stringify(err.response.data).replace(/[^\w.\s:]/g, '').replace(/[.:]/g, match => match + ' ')
              if (data) { message = data }
            }
          }
          this.showMessage(['error', message])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    closeEdit () {
      this.$emit('closed')
    },
    convertObjectToURLParams (obj) {
      let params = ''
      for (let key in obj) {
        if (params) {
          params += "&"
        }
        params += key + "=" + obj[key]
      }
      return params
    }
  }
}
</script>

<style lang="scss" scoped>
.custom-border {
  border: 1px solid var(--v-neutral300);
}
</style>